import { Link } from "react-router-dom";
import { Scissors, ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-[#f5f5f5]" data-testid="privacy-page">
      <header className="border-b border-[#2a2a2a] h-16 flex items-center px-5">
        <Link to="/" className="flex items-center gap-2 text-[#a3a3a3]" data-testid="privacy-back"><ArrowLeft className="w-4 h-4" /><Scissors className="w-5 h-5 text-[#d4af37]" /><span className="font-bold">NAKAMA</span></Link>
      </header>
      <div className="max-w-2xl mx-auto px-5 py-10 space-y-6 text-[#d4d4d4] text-sm leading-relaxed">
        <div>
          <h1 className="text-2xl font-extrabold text-[#f5f5f5]">Aviso de Privacidad</h1>
          <p className="text-[#737373] mt-1">Última actualización: junio de 2026</p>
        </div>

        <p><strong className="text-[#f5f5f5]">Barbería Nakama S.A. de C.V.</strong> (en adelante "Barbería Nakama"), con domicilio en Calle 81 #338 x 24 y 26, Col. Morelos Oriente, C.P. 97174, Mérida, Yucatán, es responsable del tratamiento de sus datos personales conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).</p>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Datos que recabamos</h2>
          <p>Nombre, teléfono, correo electrónico, fecha de cumpleaños e historial de servicios y citas. Solo si usted lo autoriza en sucursal: fotografías de su rostro y cabello (de frente y/o de perfil) para el servicio Nakama IA.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Finalidades principales (necesarias)</h2>
          <p>Agendar y gestionar sus citas, prestar el servicio de barbería, administrar su tarjeta de lealtad y puntos, y enviarle códigos de verificación y confirmaciones.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Finalidades secundarias (opcionales)</h2>
          <p>Enviarle promociones, felicitaciones de cumpleaños e invitaciones a dejar reseñas. Si no desea estas finalidades, puede indicarlo al correo de contacto.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Nakama IA · Simulador de cortes</h2>
          <p>Si usted lo acepta, en sucursal su barbero puede tomarle o adjuntar una fotografía de frente y/o de perfil para simular cómo se vería con un corte de cabello. Para ello:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><b>Consentimiento:</b> el barbero le pedirá su autorización expresa antes de tomar o adjuntar la foto. El servicio es voluntario y puede negarse sin que afecte su atención.</li>
            <li><b>Finalidad única:</b> la foto se usa solo para estimar su tipo de rostro y de cabello, recomendarle cortes y generar la simulación. No se usa para identificarle, ni con fines publicitarios, ni se publica.</li>
            <li><b>Proveedor:</b> la imagen se procesa mediante un proveedor de inteligencia artificial que actúa como encargado, únicamente para generar el resultado.</li>
            <li><b>Conservación:</b> las fotografías y simulaciones se <b>eliminan automáticamente de nuestros sistemas en un plazo máximo de 24 horas</b>. No las asociamos a su expediente de cliente.</li>
            <li><b>Copia personal:</b> si usted lo desea, el barbero puede guardar o compartir la imagen simulada en su propio dispositivo (lleva la marca de agua de Nakama).</li>
            <li><b>Resultado:</b> la simulación es una referencia visual y no garantiza el resultado real del corte.</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Transferencias</h2>
          <p>No vendemos ni compartimos sus datos con terceros, salvo proveedores que nos ayudan a operar (por ejemplo, el envío de correos electrónicos y el procesamiento de las simulaciones de Nakama IA) y cuando la ley lo exija.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Derechos ARCO</h2>
          <p>Usted puede Acceder, Rectificar, Cancelar u Oponerse al uso de sus datos, así como revocar su consentimiento, enviando su solicitud al correo <a href="mailto:Barberianakama@gmail.com" className="text-[#d4af37] hover:underline">Barberianakama@gmail.com</a>.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Cambios al aviso</h2>
          <p>Cualquier modificación a este Aviso de Privacidad se publicará en esta misma página.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-[#d4af37]">Contacto</h2>
          <p>Barbería Nakama S.A. de C.V. · Calle 81 #338 x 24 y 26, Col. Morelos Oriente, C.P. 97174, Mérida, Yucatán.<br />Correo: <a href="mailto:Barberianakama@gmail.com" className="text-[#d4af37] hover:underline">Barberianakama@gmail.com</a> · Tel/WhatsApp: 9991149730</p>
        </section>

        <Link to="/terminos" className="inline-block text-[#d4af37] font-semibold hover:underline" data-testid="privacy-to-terms">Ver Términos y Condiciones →</Link>
      </div>
    </div>
  );
}
